import { ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from '../firebaseConfig';
import { v4 as uuidv4 } from 'uuid';

export const uploadImage = (image, onError, onComplete) => {
  if (!image) {
    throw new Error('No image file provided');
  }

  const uniqueImageName = `${uuidv4()}.jpg`;
  const storageRef = ref(storage, `public/${uniqueImageName}`);
  const uploadTask = uploadBytesResumable(storageRef, image);

  uploadTask.on(
    'state_changed',
    null, // Progress function (optional)
    (error) => {
      if (onError) onError(error);
    },
    async () => {
      try {
        const cdnUrl = `${process.env.REACT_APP_IMAGE_CDN_URL}/${uniqueImageName}`;
        if (onComplete) onComplete([uniqueImageName, cdnUrl]);
      } catch (error) {
        if (onError) onError(error);
      }
    }
  );
};
